// radioProgrammer.js
var RadioProgrammer = pc.createScript('radioProgrammer');

RadioProgrammer.attributes.add('timeIntervall', {type:'number'});
RadioProgrammer.attributes.add('banners', {type:'entity', array:true});
RadioProgrammer.attributes.add('planetData', {type:'entity', array:true});
RadioProgrammer.attributes.add('thePause', {type:'number'});
RadioProgrammer.attributes.add('artistList', {type:'asset', assetType:'json'});
RadioProgrammer.attributes.add('artistName', {type:'entity'});
RadioProgrammer.attributes.add('artistLink', {type:'entity'});



// initialize code called once per entity
RadioProgrammer.prototype.initialize = function() {

    this.app.on('userInput:objectSelected', this.changePlanet, this);
    this.app.on('systemGenerator:reset', this.resetScene, this);

    var that = this;
   // this.theUrl = 'https://pocketverse.net/radioV2/rConfig/radioConfig.json';//'https://erwinorb.ath.cx/pocketverse/radioConfig.json';
    this.tList = null;
    //this.app.assets.loadFromUrl(this.theUrl, 'json', function (err, asset) {
    //    that.app.assets.add(asset);
    //    that.setExternalConfig(asset);
    // });

    this.al = null;
    this.timeIntervall = 0;
    this.thePause = 0;
    this.sysBeforeRestart = 0;
    
    this.si = this.app.root.findByName('soundIcon');
    this.si.script.soundHandler.active = false;
    this.cb = false;

    this.app.systems.sound.volume = 0;
    this.allItems = [];
    this.systemCounter = 0;
    this.setExternalConfig();

};

RadioProgrammer.prototype.setExternalConfig = function(a){
    
    this.al = this.artistList.resource;
    this.timeIntervall = parseInt(this.al.config[0].timeIntervall, 10);
    this.thePause = parseInt(this.al.config[0].pause, 10);
    this.sysBeforeRestart = parseInt(this.al.config[0].sysBeforeRestart, 10);
    this.setTimer(this.timeIntervall);

};

RadioProgrammer.prototype.resetScene = function(){

    this.systemCounter += 1;
    if(this.systemCounter == this.sysBeforeRestart){
        var rnd = Math.random(0,1);
        rnd = rnd.toFixed(12)
        window.open('https://pocketverse.net/radioV2/?s=' + rnd + '&ap=true', '_self');
    }

};

RadioProgrammer.prototype.changePlanet = function(ent){

    var self = this;
    setTimeout(function(){
        if(ent.name == 'system'){
            return;
        }
        var prob = Math.floor(Math.random(0,1)*10);
        var rndFX = Math.floor(Math.random(0,1)*self.planetData.length);
        if(prob > 2){
            self.planetData[rndFX].script.hover.up();
        }
    }, 250);

};

RadioProgrammer.prototype.setTimer = function(tm){

    var that = this;

    setTimeout(function(){
      var ban = [];
      ban = that.banners;
      var rnd = Math.floor(Math.random(0,1)*ban.length);
      var banRan = ban[rnd];
      that.fadebanner(banRan, 1);
      that.cb = true;
        that.setTimer(that.timeIntervall);
    }, tm);

};

RadioProgrammer.prototype.fadebanner = function(ent, dir){
    
    if(!this.cb){
        if(ent.name == 'banner_artists'){
            var rn = Math.floor(Math.random(0,1)*this.al.artists.length);
            this.artistName.element.text = this.al.artists[rn].name;
            this.artistLink.element.text = this.al.artists[rn].links;
        }
    
    }
    var that = this;

    this.allItems = [];
    this.allItems = ent.children;

    ent.enabled = true;
    if(!this.cb){
        for(var op = 0; op < this.allItems.length; op++){
            this.allItems[op].element.opacity = 0;
        }
    }

    var data = {opac: 0.0};
    var trgt = 0.0;

    if(dir == 1){
        data = {opac: 0.0};
        trgt = 1;
    } else if(dir == -1){
        data = {opac: 1.0};
        trgt = 0;
    }

    this.entity.tween(data).to({opac:trgt}, 1.5, pc.Linear).on('update', function(){
        for(var i = 0; i < that.allItems.length; i++){
            if(that.allItems[i].name == 'black'){
                that.allItems[i].element.opacity = data.opac*0.85;
            } else {
                that.allItems[i].element.opacity = data.opac;
            }
        }
    })
    .on('complete', function(){
        if(that.cb){
            that.tCallBack(ent);
        } else {

        }
    })
    .start();

};

RadioProgrammer.prototype.tCallBack = function(e){
    
    var that = this;
    setTimeout(function(){
        if(that.cb){
            that.fadebanner(e, -1);
            that.cb = false;
        }
    }, that.thePause);

};

RadioProgrammer.resetScene = function(){
    var oldHierarchy = pc.app.root.findByName("Root");    
    oldHierarchy.destroy();  
    this.app.loadSceneHierarchy('1300749.json', function (err, parent) { 
    });
};


// update code called every frame
RadioProgrammer.prototype.update = function(dt) {

};

// swap method called for script hot-reloading
// inherit your script state here
// RadioProgrammer.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

